<script setup lang="ts">
  import { IconMapPinned } from '@gat-ship/icons'
  import { Button } from '../ui/button'
  import {
    Empty,
    EmptyContent,
    EmptyDescription,
    EmptyHeader,
    EmptyMedia,
    EmptyTitle
  } from '../ui/empty'
</script>

<template>
  <main
    class="bg-background grid min-h-full place-items-center px-6 py-24 sm:py-32 lg:px-8"
  >
    <Empty>
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <IconMapPinned />
        </EmptyMedia>
        <EmptyTitle>404 – Page not found</EmptyTitle>
        <EmptyDescription>
          Sorry, we couldn’t find the page you’re looking for.
        </EmptyDescription>
      </EmptyHeader>
      <EmptyContent>
        <Button as-child>
          <a href="/">Go back home</a>
        </Button>
      </EmptyContent>
    </Empty>
  </main>
</template>
